import { FC, memo, useRef } from 'react';
import { ReactComponent as PlaylistIcon } from 'resources/images/playlist.svg';
import { useUniqueSvgId } from 'app/utils/hooks';
import {
  Flex,
  FlexProps,
  Icon,
  Image,
  Link,
  useStyleConfig,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

export interface PlaylistCoverProps extends FlexProps {
  size?: 'tiny' | 'small' | 'medium' | 'big';
  to?: string;
  onLinkClick?: () => void;
  image?: string;
}

const PlaylistCoverComponent: FC<PlaylistCoverProps> = ({
  size = 'big',
  to,
  onLinkClick,
  image,
  ...rest
}) => {
  const style = useStyleConfig('PlaylistCover', { size });
  const ref = useRef<SVGSVGElement>(null);
  useUniqueSvgId(ref, size.toString());

  const CoverImage = image ? (
    <Image src={image} sx={style} />
  ) : (
    <Icon ref={ref} as={PlaylistIcon} sx={style} data-testid="playlist-cover" />
  );

  return (
    <Flex {...rest}>
      {to ? (
        <Link as={RouterLink} to={to} fontSize={0} onClick={onLinkClick}>
          {CoverImage}
        </Link>
      ) : (
        CoverImage
      )}
    </Flex>
  );
};

export const PlaylistCover = memo(PlaylistCoverComponent);
